import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import {useEvent} from 'Event/EventProvider'
import {api, obvioUrl} from 'lib/url'
import {obvioRoutes} from 'obvio/Routes'
import Page from 'organization/Event/Page'
import {useSetEventAuthRoute} from 'organization/Event/Services/Apps/HubspotV2/HubspotV2AuthCallbackHandler'
import {useOrganization} from 'organization/OrganizationProvider'
import React, {useState} from 'react'

export default function LinkPage() {
  const {link, isProcessing} = useLink()

  return (
    <Page>
      <Typography variant="h4">Hubspot V2</Typography>
      <p>
        Click the button below to link obv.io with Hubspot V2.
        <br />
        You will be redirected to Hubspot V2 to complete authorization.
      </p>
      <Button
        color="primary"
        variant="contained"
        disabled={isProcessing}
        onClick={link}
        aria-label="authorize"
      >
        Authorize
      </Button>
    </Page>
  )
}

function useLink() {
  const {client} = useOrganization()
  const {event} = useEvent()
  const [isProcessing, setIsProcessing] = useState(false)
  const redirectUrl = useRedirectUrl()
  const setEventAuthRoute = useSetEventAuthRoute()

  const linkUrl = api(`/events/${event.id}/integrations/hubspot_v2/link`)

  const link = () => {
    if (isProcessing) {
      return
    }

    setIsProcessing(true)
    client
      .post<{auth_url: string}>(linkUrl, {
        redirect_url: redirectUrl,
      })
      .then(({auth_url}) => {
        // Redirect to HubspotV2
        setEventAuthRoute()
        window.location.href = auth_url
      })
      .catch(() => {
        setIsProcessing(false)
      })
  }

  return {link, isProcessing}
}

export function useRedirectUrl() {
  return `${obvioUrl(obvioRoutes.hubspot_v2.auth)}`
}
